import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import usersSagas from './users/saga';
import empresaSagas from './empresa/saga';
import paineisSagas from './paineisUsers/saga';
import gruposControleSagas from './gruposControle/saga';
import fatorSagas from './fator/saga';
import estoqueSagas from './estoque/saga';
import curvaSagas from './curva/saga';
import categoriasSagas from './categorias/saga';
import parametrosEmbeddedBiSagas from './parametrosBi/parametrosEmbeddedBi/saga';
import painelSagas from './paineis/saga';
import classificacoesSagas from './classificacoes/saga';
import motivos from './motivosStatusEmpresa/saga';
import parametrosGlobais from './parametrosGlobais/saga';
import parametrosLocais from './parametrosLocais/saga';
import dadosExternos from './dadosExternos/saga';
import construtorRelatorios from './construtorRelatorios/saga';
import cloudFlare from './cloudFlare/saga';
import machines from './pgloader/machines/saga';
import shedules from './pgloader/shedules/saga';
import logs from './pgloader/logs/saga';
import definicoesPbiSagas from './definicoesPbi/saga';
import chatIASagas from './chatIA/saga';
import sourcesGlobaisSaga from './sourcesGlobais/saga';
import validacaoRelatoriosIqviaSaga from './validacaoRelatoriosIqvia/saga';
import infoFinanceirasSagas from './infoFinanceiras/saga';

export default function* rootSaga(getState: any) {
  yield all([
    authSagas(),
    usersSagas(),
    empresaSagas(),
    paineisSagas(),
    gruposControleSagas(),
    fatorSagas(),
    estoqueSagas(),
    curvaSagas(),
    categoriasSagas(),
    parametrosEmbeddedBiSagas(),
    painelSagas(),
    classificacoesSagas(),
    motivos(),
    parametrosGlobais(),
    construtorRelatorios(),
    parametrosLocais(),
    dadosExternos(),
    cloudFlare(),
    machines(),
    shedules(),
    logs(),
    chatIASagas(),
    sourcesGlobaisSaga(),
    definicoesPbiSagas(),
    validacaoRelatoriosIqviaSaga(),
    infoFinanceirasSagas()
  ]);
}
